







































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { ColorFamily, ColorFamilyName } from '@/models/tag/color-family'
import { ColorFamilyState } from '@ajax/vue/components/templates/model/condition/state/color-family'

@Component
export default class ColorPicker extends Vue {

  @Prop({ required: true })
  state: ColorFamilyState

  @Prop({ required: true })
  handleOnChange: (item: any) => void

  @Prop({ required: true })
  handleClear: () => void

  get colorList(): ColorFamily[] {
    return this.state.list.list
  }

  isChecked(name: ColorFamilyName): boolean {
    return this.state.isChecked(name)
  }

  colorPickerItemClass(name: ColorFamilyName) {
    return {
      'c-form--checkbox--color__check': true,
      [`c-color-picker--item__color--${name}`]: true,
    }
  }
}
